import ImageText from './ImageText';

export { ImageText };
export default ImageText;
